<template>
  <div class="member-info">
    <div class="member-panel-left">
      <!--左上面板-->
      <div class="member-upper-left">
        <div style="flex: 4">
          <span
            class="member-avatar"
            :style="`background-image: url(${avatarPre + infoBox.avatar})`"
            v-if="!infoBox.loadingData"
          >
            <el-upload
              class="upload-btn"
              action
              multiple
              :disabled="!uploadFlag"
              :show-file-list="false"
              fullscreen="true"
              :accept="attaFileSuf"
              :limit="1"
              :before-upload="handleBeforeUpload"
              :http-request="updateAvatar"
              :on-exceed="handleExceed"
            >
              <a
                v-if="uploadFlag"
                href="javascript:void(0)"
                class="member-avatar-click"
                >更换头像</a
              >
            </el-upload>
          </span>
        </div>
        <div style="flex: 2">
          <span class="member-inner">
            <div
              class="member-name iconfont"
              :class="{
                'icon-nan1': infoBox.gender == '1',
                'icon-nv': infoBox.gender == '0'
              }"
              v-if="!infoBox.loadingData"
            >
              {{ infoBox.name }}
            </div>
            <div class="member-dept">
              <span v-if="infoBox.tp == '6'">{{ infoBox.pname }}</span>
              <span v-else>{{ infoBox.departmentName }}</span>
            </div>
            <div class="member-inner-info">
              <span class="member-inner-phone">{{ infoBox.userId }}</span>
            </div>
          </span>
        </div>
        <div style="flex: 2">
          <span class="member-operation">
            <button class="export-resume" @click="handleExportClick">
              导出简历
            </button>
          </span>
        </div>
      </div>

      <!--左下面板-->
      <div class="member-lower">
        <div class="member-lower-left">
          <li
            v-for="(item, index) in leftMenuList"
            :key="item.name"
            @click="handleChangeClick(item, index)"
          >
            {{ item.name }}
          </li>
        </div>
        <div class="member-lower-button">
          <button @click="handleBackClick">返回</button>
        </div>
      </div>
    </div>

    <div class="member-panel-right">
      <div class="member-right-head-outer">
        <div class="member-right-head">
          <li
            v-for="item in rightMenuList"
            :key="item.name"
            @click="handleChildrenClick(item)"
          >
            {{ item.name }}
          </li>
        </div>
      </div>

      <!--上下衔接-->
      <div class="member-head-inner-link"></div>
      <div class="member-right-inner">
        <!--中间主要内容区域-->
        <div id="member-right-data" class="member-right-inner-panel">
          <router-view
            ref="memberData"
            :childrenMenuIndex="childrenMenuIndex"
            :autoClick="autoClick"
            :leftMenuIndex="leftMenuIndex"
            :leftMenuItem="leftMenuItem"
            @getEditFlag="getEditFlag"
            @changeRightMenu="changeRightMenu"
            @clickLeftMenu="clickLeftMenu"
          />
        </div>
      </div>

      <!--用于撑大内容区域-->
      <div id="panel-margin"></div>
    </div>

    <el-dialog
      width="30%"
      :visible.sync="formatDialog.isShow"
      class="export-dialog"
      @close="handleCancelClick"
    >
      <div class="dialog-title" slot="title">
        <template>导出简历</template>
      </div>
      <div class="dialog-body">
        <el-row>
          <div style="margin-bottom: 20px">请选择导出格式</div>
        </el-row>
        <el-row>
        <div>
          <el-col :span="8">
            <el-radio v-model="formatDialog.radio" label="word" size="medium"
              >word文档</el-radio
            >
          </el-col>
          <el-col :span="8">
            <el-radio v-model="formatDialog.radio" label="pdf" size="medium"
              >pdf文档</el-radio
            >
          </el-col>
            <el-col :span="8">
            <el-radio v-model="formatDialog.radio" label="excel" size="medium"
              >excel文档</el-radio
            >
          </el-col>
        </div>
        </el-row>
        <el-row>
           <div style="margin: 20px 0;">请选择导出模块</div>
        </el-row>
        <el-row>
          <el-col :span="8" style="margin: 10px 0;">
            <el-checkbox class="checkbox-size" :indeterminate="exportModuleInfo.isIndeterminate" label="全部" @change="handleCheckAllExportChange"></el-checkbox>
          </el-col>
          <el-checkbox-group v-model="exportModuleInfo.exportList" @change="handleCheckedExportChange">
            <el-col :span="8" style="margin: 10px 0;" v-for="item in exportModuleInfo.stayExportList" :key="item">
              <el-checkbox class="checkbox-size" :label="item"></el-checkbox>
            </el-col>
          </el-checkbox-group>
        </el-row>
      </div>
      <div class="dialog-footer">
        <button class="cancel-button" @click="handleCancelClick">取消</button>
        <button
          class="ok-button"
          style="margin-right: 30px"
          @click="handleOkClick"
        >
          确定
        </button>
      </div>
    </el-dialog>

    <animation
      :loading-data-visible="infoBox.loadingData"
      :loading-text="infoBox.loadingText"
    />
  </div>
</template>

<script>
import Pen from "@/components/custom/Pen";
import BasicUpdateInfo from "../../components/member/BasicUpdateInfo";
import Animation from "@/components/loading/animation";
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import { Message } from "element-ui";
import { AVATAR_UPLOAD_COMPONENT_TYPE_STR } from "@/constants/constants";
const categoryOptions = [
  "基本信息",
  "科研成果",
  "教学",
  "临床能力",
  "社会影响力"
];
import { mapState } from "vuex";

export default {
  name: "MemberData",
  components: {
    Pen,
    BasicUpdateInfo,
    Animation
  },
  data() {
    return {
      leftMenuList: [
        {
          name: "基本信息",
          childrenPath: [
            "basic",
            "learning",
            "working",
            "certificate",
            "personalHonoraryTitle"
          ],
          path: "/privateplot/member/basic",
          children: [
            { path: "/privateplot/member/basic", name: "基本信息" },
            { path: "/privateplot/member/learning", name: "学习经历" },
            { path: "/privateplot/member/working", name: "工作经历" },
            { path: "/privateplot/member/certificate", name: "资格证书" },
            {
              path: "/privateplot/member/personalHonoraryTitle",
              name: "个人荣誉称号"
            }
          ]
        },
        {
          name: "科研成果",
          childrenPath: [
            "paper",
            "subject",
            "gcp",
            "work",
            "patent",
            "award",
            "standardization"
          ],
          path: "/privateplot/member/paper",
          children: [
            { path: "/privateplot/member/paper", name: "论文" },
            { path: "/privateplot/member/subject", name: "课题" },
            { path: "/privateplot/member/gcp", name: "GCP" },
            { path: "/privateplot/member/work", name: "著作" },
            { path: "/privateplot/member/patent", name: "专利" },
            { path: "/privateplot/member/award", name: "获奖" },
            { path: "/privateplot/member/standardization", name: "标准化建设" }
          ]
        },
        {
          name: "教学",
          childrenPath: [
            // 'countTeaching',
            "teacher",
            "teaching"
          ],
          path: "/privateplot/member/teacher",
          children: [
            // {path: '/privateplot/member/countTeaching', name: "统计"},
            // {path: '', name: "评分"},
            { path: "/privateplot/member/teacher", name: "导师信息" },
            { path: "/privateplot/member/teaching", name: "大学教学" }
          ]
        },
        {
          name: "临床能力",
          childrenPath: [
            "operation",
            "techniques",
            "admitted",
            "outpatient",
            "mdtCase"
          ],
          path: "/privateplot/member/operation",
          children: [
            { path: "/privateplot/member/operation", name: "手术" },
            { path: "/privateplot/member/techniques", name: "临床开展新技术" },
            { path: "/privateplot/member/admitted", name: "收治住院人数" },
            { path: "/privateplot/member/outpatient", name: "门诊量" },
            { path: "/privateplot/member/mdtCase", name: "MDT病例" }
          ]
        },
        {
          name: "社会影响力",
          childrenPath: [
            "socialPosts",
            "volunteerActivities",
            "popularScience",
            "meeting",
            "consultation",
            "support",
            "partyConstruction",
            "famousDoctorStudio"
          ],
          path: "/privateplot/member/socialPosts",
          children: [
            { path: "/privateplot/member/socialPosts", name: "社会任职" },
            {
              path: "/privateplot/member/volunteerActivities",
              name: "义诊活动"
            },
            { path: "/privateplot/member/popularScience", name: "科普类" },
            {
              path: "/privateplot/member/meeting",
              name: "学术会议、继续教育学习班"
            },
            { path: "/privateplot/member/consultation", name: "会诊" },
            { path: "/privateplot/member/support", name: "对口支援" },
            { path: "/privateplot/member/partyConstruction", name: "党建工作" },
            {
              path: "/privateplot/member/famousDoctorStudio",
              name: "名医工作室"
            }
            // {path: '/privateplot/member/collegeBaseCentre', name: "专科学术联盟、基地、中心"},
          ]
        }
      ],
      leftMenuActiveIndex: 0,
      rightMenuList: [], //右边菜单栏目录
      dialog: {
        isShow: false,
        checkAll: false,
        checkedCategorys: [],
        categorys: categoryOptions,
        isIndeterminate: true
      },
      formatDialog: {
        isShow: false,
        radio: ""
      },
      childrenMenuIndex: 0,
      autoClick: 0,
      scrollFlag: false,
      editAllFlag: false,
      leftMenuIndex: 0,
      leftMenuItem: {},
      avatarPre: "",
      attaFileSuf: AVATAR_UPLOAD_COMPONENT_TYPE_STR,
      infoBox: {
        loadingData: false,
        loadingText: "",
        avatar: null,
        departmentName: "",
        gender: null,
        name: "",
        userId: "",
        tp: "",
        pname: ""
      },
      uploadFlag: false,

      //导出模块的基本信息
      exportModuleInfo: {

        //待导出的模块
        stayExportList: ["基本信息", "科研成果", "教学", "临床能力", "社会影响力"],

        //导出模块的列表
        exportList: ["基本信息", "科研成果", "教学", "临床能力", "社会影响力"],

        checkAllExport: true,

        isIndeterminate: true,
      }
    };
  },
  created() {
    this.avatarPre = window.config.avatar.baseUrl + "/";
    // 在页面加载时读取sessionStorage
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {
    let userId = this.$store.state.MemberManageModule.userId;
    let type = this.$store.state.MemberManageModule.type;
    if (userId == null && type !== "view") {
      this.uploadFlag = true
    } else {
      this.uploadFlag = false
    }
    let path = this.$route.path;
    let idx = null;
    for (let i in this.leftMenuList) {
      let leftMenuListElement = this.leftMenuList[i];
      let number = leftMenuListElement.childrenPath.findIndex(
        item => path.indexOf(item) > -1
      );
      if (number > -1) {
        idx = Number(i);
        this.rightMenuList = this.leftMenuList[i].children;
        break;
      }
    }

    this.$nextTick(args => {
      this.getMemberInfo();
      this.initPage(idx);
    });
  },
  methods: {
    handleBackClick() {
      if (
        this.$store.state.MemberManageModule.userId &&
        this.$store.state.MemberManageModule.userId != null
      ) {
        this.$store.dispatch("clearUserId");
        this.$store.dispatch("clearType");
        this.$router.push({ path: "/user/manage" });
      } else {
        this.$router.push({ path: "/dashboard" });
      }
    },

    getEditFlag(data) {
      this.editAllFlag = data;
    },

    //改变菜单栏
    handleChangeClick(item, idx) {
      this.leftMenuIndex = idx;
      this.leftMenuItem = item;
      if (!this.editAllFlag) {
        this.rightMenuList = JSON.parse(JSON.stringify(item.children));
        this.clearChooseStyle();
        this.$nextTick(args => {
          this.initPage(idx);
        });
      }
      this.handleChildrenClick(item);
    },

    //子路由跳转
    handleChildrenClick(item) {
      this.$router.push({ path: item.path });
    },

    handleExportClick() {
      this.formatDialog.isShow = true;
    },

    //改变所有面板的状态
    closeAll() {
      for (let that of Object.keys(this.$refs)) {
        this.$refs[that].closAbleHandler(true);
      }
    },

    initPage(idx) {
      //左边菜单的样式
      let dom = document.getElementsByClassName("member-lower-left");
      //设置第一个菜单栏为选中的状态
      dom[0].children[idx ? idx : 0].setAttribute(
        "style",
        "border-left: #34c5e7 3px solid;color: #34c5e7;"
      );
      let list = [...dom[0].children];
      list.forEach((item, index) => {
        if (index == idx) {
          //设置左边激活选中的菜单id
          this.leftMenuActiveIndex = index
          item.setAttribute(
            "style",
            "border-left: #34c5e7 3px solid;color: #34c5e7;"
          );
        } else {
          item.setAttribute(
            "style",
            "border-left: transparent 3px solid;color: black;"
          );
        }
      });

      //右边的菜单样式
      let rightDom = document.getElementsByClassName("member-right-head");
      for (let child of rightDom[0].children) {
        child.addEventListener("click", () => {
          for (let other of rightDom[0].children) {
            other.setAttribute(
              "style",
              "border-bottom: transparent 3px solid;color: black;"
            );
          }
          child.setAttribute(
            "style",
            "border-bottom: #34c5e7 3px solid;color: #34c5e7;"
          );
          this.changeRightMenu();

        });
      }
      //设置第一个菜单栏为选中的状态
      let path = this.$route.path;
      let number = this.leftMenuList[idx ? idx : 0].childrenPath.findIndex(
        item => path.indexOf(item) > -1
      );
      if (rightDom[0].children && rightDom[0].children.length > 0) {
        if (number) {
          rightDom[0].children[Number(number)].setAttribute(
            "style",
            " border-bottom: #34c5e7 3px solid;color: #34c5e7;"
          );
        } else {
          rightDom[0].children[0].setAttribute(
            "style",
            " border-bottom: #34c5e7 3px solid;color: #34c5e7;"
          );
        }
      }
    },

    clearChooseStyle() {
      let rightDom = document.getElementsByClassName("member-right-head");
      for (let child of rightDom[0].children) {
        child.setAttribute(
          "style",
          "border-bottom: transparent 3px solid;color: black;"
        );
      }
    },

    handleCheckedExportChange(value) {
      let checkedCount = value.length;
      this.exportModuleInfo.checkAllExport = checkedCount === this.exportModuleInfo.stayExportList.length;
      this.exportModuleInfo.isIndeterminate = checkedCount > 0 && checkedCount < this.exportModuleInfo.stayExportList.length;
    },

    //是否选中所有的模块导出
    handleCheckAllExportChange(val) {
      this.exportModuleInfo.exportList = val ? this.exportModuleInfo.stayExportList: [];
      this.exportModuleInfo.isIndeterminate = false;
    },

    //复选框
    handleCheckAllChange(val) {
      this.dialog.checkedCategorys = val ? categoryOptions : [];
      this.dialog.isIndeterminate = false;
    },
    handleCheckedCategorysChange(value) {
      let checkedCount = value.length;
      this.dialog.checkAll = checkedCount === this.dialog.categorys.length;
      this.dialog.isIndeterminate =
        checkedCount > 0 && checkedCount < this.dialog.categorys.length;
    },

    //确定按钮
    handleOkClick() {
      if (!this.formatDialog.radio) {
        Message.warning("请选择简历导出格式");
        return false;
      }
      if (this.exportModuleInfo.exportList === null || this.exportModuleInfo.exportList.length === 0) {
        Message.warning("请选择简历导出模块");
        return false;
      }
      let exportModuleStr = this.exportModuleInfo.exportList.join(",");
      let token = cookie.getCookie("token");
      window.open(
        window.config.api.baseUrl +
          "/eims-api/personal/data/dynamicTable?token=" +
          token +
          "&userId=" +
          (this.$store.state.MemberManageModule.userId
            ? this.$store.state.MemberManageModule.userId
            : "") +
          "&flag=" +
          this.formatDialog.radio +
          "&export="+ exportModuleStr
      );
      this.formatDialog.isShow = false;
    },

    //取消按钮
    handleCancelClick() {
      this.formatDialog.isShow = false;
      this.formatDialog.radio = "";
      this.exportModuleInfo.exportList = this.$options.data().exportModuleInfo.exportList
    },

    changeRightMenu(obj) {

      let rightIndex = 0;


      for (let i = 0; i < this.leftMenuList[this.leftMenuActiveIndex].children.length; i++) {
        let child = this.leftMenuList[this.leftMenuActiveIndex].children[i];
        if (child.path.indexOf(this.$route.path) > -1) {
          rightIndex = i;
        }
      }
      // let leftDom = document.getElementsByClassName("member-left-head");
      // leftDom[0].children[obj.right].click();
      let rightDom = document.getElementsByClassName("member-right-head");
      if (rightDom[0].children && rightDom[0].children.length > 0) {
        for (let other of rightDom[0].children) {
          other.setAttribute(
            "style",
            "border-bottom: transparent 3px solid;color: black;"
          );
        }
        rightDom[0].children[Number(rightIndex)].setAttribute(
          "style",
          " border-bottom: #34c5e7 3px solid;color: #34c5e7;"
        );
      }
    },

    clickLeftMenu(obj) {
      let number = this.leftMenuList.findIndex(
        item => item.path.indexOf(obj.path) > -1
      );
      if (number != -1) {
        let leftMenuListElement = this.leftMenuList[number];
        this.handleChangeClick(leftMenuListElement, number);
      }
    },

    scrollMoveMenu(data) {
      this.scrollFlag = true;
      let rightDom = document.getElementsByClassName("member-right-head");
      rightDom[0].children[data].click();
      this.scrollFlag = false;
    },

    clickMenuMoveScroll(idx) {
      this.childrenMenuIndex = idx;
      if (this.scrollFlag) {
        this.autoClick = 0;
      } else {
        this.autoClick = 1;
      }
    },

    getMemberInfo() {
      let _this = this;
      _this.infoBox.loadingData = true;
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/personal/data/userInfo", {
          token: token,
          data: { userId: this.$store.state.MemberManageModule.userId }
        })
        .then(response => {
          if (response.data.code === "00000") {
            this.infoBox.avatar = response.data.data.userInfo.avatar;
            this.infoBox.departmentName =
              response.data.data.userInfo.departmentName;
            this.infoBox.gender = response.data.data.userInfo.gender;
            this.infoBox.name = response.data.data.userInfo.name;
            this.infoBox.userId = response.data.data.userInfo.userId;
            this.infoBox.tp = response.data.data.userInfo.tp;
            this.infoBox.pname = response.data.data.userInfo.pname;
          }
        })
        .finally(() => {
          _this.infoBox.loadingData = false;
        });
    },
    handleExceed(files, fileList) {
      this.$message({
        message: "只允许选择上传一个图片！",
        type: "error",
        showClose: true
      });
    },

    handleBeforeUpload(file) {
      let testMsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (!this.attaFileSuf.includes(testMsg)) {
        this.$message({
          message: "上传附件类型不合法！",
          type: "warning",
          showClose: true
        });
        return false;
      } else {
        return true;
      }
    },

    updateAvatar(file) {
      if (!file.file) {
        return;
      }
      this.infoBox.loadingData = true;
      this.infoBox.loadingText = "上传中";
      // 使用form表单的数据格式
      const paramsData = new FormData();
      paramsData.append(`file`, file.file);
      let jsonData = {
        token: cookie.getCookie("token"),
        data: {}
      };
      //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
      paramsData.append(
        "data",
        new Blob([JSON.stringify(jsonData)], { type: "application/json" })
      );
      http
        .post(window.config.api.baseUrl + "/eims-api/avatar/upload", paramsData)
        .then(value => {
          if (value.data.code === "00000") {
            Message.success({ message: "头像已更换", showClose: true });
            //重新触发刷新数据
            this.getMemberInfo();
          }
        })
        .finally(() => {
          this.infoBox.loadingData = false;
        });
    }
  },
  computed: {
    ...mapState({
      //仅需要当前页面需要的数据,无需设置其他的页面的module数据
      refreshBaseFlag: state => state.userModule.refreshBaseFlag
    })
  },
  watch: {
    refreshBaseFlag(newVal, oldVal) {
      if (newVal) {
        //重新触发刷新数据
        this.getMemberInfo();
        this.$store.commit("changeRefreshFlag", { baseFlag: false });
      }
    },

    "$route.path": {
      immediate: true,
      deep: true,
      handler(newVal) {
        let number = this.rightMenuList.findIndex(
          item => newVal.indexOf(item.path) > -1
        );
        if (number > -1) {
          let rightDom = document.getElementsByClassName("member-right-head");
          if (rightDom[0].children && rightDom[0].children.length > 0) {
            for (let other of rightDom[0].children) {
              other.setAttribute(
                "style",
                "border-bottom: transparent 3px solid;color: black;"
              );
            }
            rightDom[0].children[Number(number)].setAttribute(
              "style",
              " border-bottom: #34c5e7 3px solid;color: #34c5e7;"
            );
          }
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.path.indexOf("/privateplot/member") == -1 ||
      to.path.indexOf("/Login") != -1
    ) {
      this.$store.dispatch("clearUserId");
      this.$store.dispatch("clearType");
      sessionStorage.clear();
    }
    next();
    return;
  }
};
</script>

<style lang="scss" scoped>
/*dialog样式*/
/deep/.export-dialog .el-dialog__header {
  padding: 0;
}

/deep/.export-dialog .el-dialog__body {
  padding: 0;
}

.dialog-title {
  background-color: #e9f6f9;
  background-size: 100%;
  font-size: 22px;
  height: 60px;
  line-height: 60px;
  font-weight: bold;
  padding-left: 20px;
}

.dialog-body {
  padding: 20px;
}

.dialog-body .dialog-body-text {
  font-size: 30px;
  line-height: 25px;
}

/*多选框样式*/
/deep/ .el-checkbox__label {
  padding-left: 20px;
  font-size: 18px;
  line-height: 18px;
}

/deep/ .el-checkbox__inner {
  width: 18px;
  height: 18px;
}

/deep/ .el-checkbox__inner::after {
  height: 9px;
  left: 6px;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #34c5e7;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #34c5e7;
  border-color: #34c5e7;
}

.dialog-footer {
  margin-top: 40px;
  border-top: 1px solid #e4e7ed;
  padding: 20px;
  height: 85px;
}

.member-info {
  /*height: 100vh;*/
}

.member-panel-left {
  float: left;
}

.member-upper-left {
  overflow-y: auto;
  top: 69px;
  position: fixed;
  margin: 20px;
  width: 300px;
  height: calc(45vh - 60px);
  background-color: white;
  box-shadow: #d0cece 1px 1px 10px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.member-lower {
  height: calc(55vh - 60px);
  width: 300px;
  top: calc(45vh + 39px);
  position: fixed;
  margin: 20px;
  margin-top: 0;
  background-color: white;
  box-shadow: #d0cece 1px 1px 10px;
  border-radius: 10px;
  padding-top: 20px;
}

.member-lower-left {
  height: calc(55vh - 140px);
  overflow-y: auto;
}

.member-lower-button {
  height: 60px;
  padding: 10px 40px;
}

.member-lower-button button {
  border: 1px solid #3ec4db;
  border-radius: 3px;
  width: 100%;
  height: 40px;
  background-color: #ffffff;
  color: #34c5e7;
}

.member-lower-button button:hover {
  background-color: #caced5;
}
.member-lower-button button:active {
  background-color: #8c939d;
}

.member-right-head-outer {
  width: calc(100% - 330px);
  height: 100px;
  background-color: #eef5fc;
  left: 330px;
  overflow: auto;
  z-index: 9;
  position: fixed;
}

.member-right-head {
  white-space: nowrap;
  overflow: auto hidden;
  z-index: 3;
  position: fixed;
  width: calc(100% - 370px);
  margin: 20px;
  left: 330px;
  background-color: white;
  border-bottom: 1px #e1e3e3 solid;
  height: 80px;
  border-radius: 10px 10px 0 0;
}

.member-right-head-before {
  transform: rotate(180deg);
}

.member-right-inner {
  top: 100px;
  position: relative;
  left: 350px;
  width: calc(100% - 370px);
  background-color: white;
}

/*右边的head和inner的衔接阴影*/
.member-head-inner-link {
  left: 370px;
  top: 163px;
  position: fixed;
  width: calc(100% - 410px);
  height: 5px;
  box-shadow: #717379 1px 1px 7px;
  z-index: 2;
  border-radius: 10px;
}

/*个人头像*/
.member-avatar {
  display: inline-block;
  margin: 20px calc(50% - 50px);
  width: 100px;
  height: 100px;
  background-size: cover;
  /*background-image: url("https://chenzy-avatar-1308425445.cos.ap-guangzhou.myqcloud.com/avatar/4_UIYICe2ESYYsW8wo08e0.jpg");*/
  border-radius: 50%;
}

/*个人名称*/
.member-name {
  margin: 5px 5px 5px 30px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

.member-dept {
  margin: 5px;
  font-size: 18px;
  text-align: center;
  white-space: pre-line;
}

.member-inner-info {
  margin: 20px 0px;
  text-align: center;
}

.member-inner-address {
  padding: 0 10px;
  margin: 0 10px;
  border-right: 2px #2c3e50 solid;
}

.dialog-footer > button {
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 14px;
  float: right;
}

.member-operation > button {
  border-radius: 5px;
  padding: 10px 60px;
  font-size: 16px;
  margin: 10px auto;
  display: block;
}

.export-resume,
.ok-button {
  border: #34c5e7 1px solid;
  background-color: #34c5e7;
  color: #ffffff;
}

.export-resume:hover,
.ok-button:hover {
  background-color: #2da3bf;
}

.export-resume:active,
.ok-button:active {
  background-color: #26849a;
}

.preview-resume,
.cancel-button {
  border: #34c5e7 1px solid;
  background-color: #ffffff;
  color: #34c5e7;
  padding: 5px 60px;
  font-size: 16px;
}

.preview-resume:hover,
.cancel-button:hover {
  background-color: #efefef;
}

.preview-resume:active,
.cancel-button:active {
  background-color: #e5e5e5;
}

/*取消图标在前面的内容*/
.icon-nan1:before {
  content: "";
}

/*将图标加在最后*/
.icon-nan1:after {
  color: #0d8efa;
  margin: 5px;
  content: "\e613";
}

/*取消图标在前面的内容*/
.icon-nv:before {
  content: "";
}

/*将图标加在最后*/
.icon-nv:after {
  color: hotpink;
  margin: 5px;
  content: "\e662";
}

li {
  cursor: pointer;
  transition-duration: 200ms;
  padding: 0px 40px;
  margin: 15px 0;
  font-size: 18px;
  /*去掉小圆点*/
  list-style: none;
  animation-duration: 500ms;
  animation-name: transformItem;
  animation-fill-mode: forwards;
}

.member-right-inner-panel {
  min-height: calc(100vh - 189px);
}

.member-lower-left > li {
  border-left: transparent 3px solid;
}

.member-lower-left > li:active {
  transition-duration: 200ms;
  border-left: #34c5e7 3px solid;
  color: #34c5e7;
}

@keyframes transformItem {
  0% {
    font-size: 18px;
  }
  50% {
    font-size: 22px;
  }
  100% {
    font-size: 18px;
  }
}

.member-right-head > li {
  padding: 0px 10px;
  padding-bottom: 10px;
  margin: 20px 10px;
  display: inline-block;
  border-bottom: transparent 4px solid;
}

.member-right-head > li:active {
  border-bottom: #34c5e7 4px solid;
  color: #34c5e7;
}

.member-right-inner-avatar {
  width: 130px;
  height: 130px;
  margin: 30px 50px;
  float: left;
}

/*利用伪元素设置外层的边框*/
.member-right-inner-avatar:before {
  position: relative;
  /*(10 + 5 px ) * 2 = 30px[ margin: 30px]*/
  /*其中变为6px是因为边框的大小为1px*/
  top: -6px;
  left: -6px;
  border-radius: 100%;
  border: #8c939d 1px solid;
  content: "";
  display: inline-block;
  width: 140px;
  height: 140px;
}

.change-avatar {
  padding: 10px 40px;
  margin: 65px 65px 0 0;
  float: right;
  border-radius: 5px;
  font-size: 18px;
  background-color: #34c5e7;
  color: white;
  border: 0px;
}

.change-avatar:hover,
.btn-close-all:active {
  background-color: #2da3bf;
}

.change-avatar:active,
.btn-close-all:active {
  background-color: #26849a;
}

.btn-close-all {
  padding: 5px 5px;
  margin: 5px 20px;
  float: right;
  border-radius: 5px;
  font-size: 16px;
  background-color: #34c5e7;
  color: white;
  border: 0px;
}

/*如果位置出现了错位的问题,可以加上clear:both;解决*/
.member-right-inner-bottom {
  clear: both;
}

/*由于使用了相对定位,主内容区域不够大,需要使用来撑大主内容区域*/
#panel-margin {
  height: 100px;
  background-color: transparent;
}
a {
  position: absolute;
  width: 100px;
  height: 100px;
  background: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  color: #fff;
  line-height: 100px;
  text-align: center;
  border-radius: 50%;
  top: 20px;
}

.member-avatar-click {
  display: none;
}

.member-avatar:hover .member-avatar-click {
  display: unset;
}

/deep/ .checkbox-size .el-checkbox__label{
  font-size: 14px;
}

/deep/ .checkbox-size .el-checkbox__inner::after{
  height: 7px;
  left: 5px;
}

/deep/ .checkbox-size .el-checkbox__inner {
  width: 14px;
  height: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/privateplot/MemberData.vue